import styled from 'styled-components';

import { Button } from 'common/components/cookbook/Button';
import { Stack } from 'common/components/cookbook/Stack';

export const NavBarControls = styled(Stack)`
  flex-shrink: 0;
`;

export const NavBarButton = styled(Button)`
  flex-shrink: 0;
`;
